import React from 'react';

import Framework from '@beardeddevops/react.framework';
import {Collections} from 'components';

const breadcrumbsStatic = [
	{
		name: 'Engineers',
		url: '/engineers',
		icon: 'dashboard',
	},
];

export default class DailyEta extends Framework.Components.View {
	render() {
		const breadcrumbs = breadcrumbsStatic.concat([
			{
				name: 'Daily ETA',
				url: '/engineers/daily_eta',
				icon: 'clock-o',
			},
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<Collections.DailyEtaBoard
					history={this.props.history}
					location={this.props.location}
					regions={this.props.regions}
					roles={this.props.roles}
					userPkey={this.props.user?.pkey || this.props.user}
					feSelfView={true}
				/>
			</div>
		);
	}
}
